import api from '../config/api';

class LeadAssignmentService {
  // Get all sales team members for assignment dropdown
  static async getSalesTeam() {
    try {
      const response = await api.get('/employee');
      return { success: true, data: response.data.data };
    } catch (error) {
      console.error('Error fetching sales team:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to fetch sales team' 
      };
    }
  }

  // Get sales departments with employees
  static async getSalesDepartments() {
    try {
      const response = await api.get('/departments/sales-departments');
      return { success: true, data: response.data.data };
    } catch (error) {
      console.error('Error fetching sales departments:', error);
      return { 
        success: false, 
        message: error.response?.data?.message || 'Failed to fetch sales departments' 
      };
    }
  }

  // Get employees by department
  static async getDepartmentEmployees(departmentId) {
    try {
      const response = await api.get(`/departments/department/${departmentId}/employees`);
      return { success: true, data: response.data.data };
    } catch (error) {
      console.error('Error fetching department employees:', error);
      return { 
        success: false, 
        message: error.response?.data?.message || 'Failed to fetch department employees' 
      };
    }
  }

  // Create sample employees if none exist
  static async createSampleEmployees() {
    try {
      const response = await api.post('/departments/create-sample-employees');
      return { success: true, data: response.data.data };
    } catch (error) {
      console.error('Error creating sample employees:', error);
      return { 
        success: false, 
        message: error.response?.data?.message || 'Failed to create sample employees' 
      };
    }
  }

  // Assign single lead to sales person
  static async assignLead(leadId, assignmentData) {
    try {
      const response = await api.put(`/lead-assignment/assign/${leadId}`, assignmentData);
      return { success: true, data: response.data.data };
    } catch (error) {
      console.error('Error assigning lead:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to assign lead' 
      };
    }
  }

  // Bulk assign multiple leads
  static async bulkAssignLeads(assignmentData) {
    try {
      const response = await api.put('/lead-assignment/bulk-assign', assignmentData);
      return { success: true, data: response.data.data };
    } catch (error) {
      console.error('Error bulk assigning leads:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to bulk assign leads' 
      };
    }
  }

  // Enhanced bulk assign with distribution logic
  static async bulkAssignLeadsWithDistribution(assignments) {
    try {
      const requestData = {
        assignments: assignments,
        assignmentNotes: assignments[0]?.notes || 'Bulk assignment via distribution algorithm',
        priority: assignments[0]?.priority || 'medium',
        assignmentMode: assignments[0]?.assignmentMode || 'replace' // Pass assignment mode
      };
      
      const response = await api.put('/lead-assignment/bulk-assign-enhanced', requestData);
      return { 
        success: true, 
        message: response.data.message,
        data: response.data.data
      };
    } catch (error) {
      console.error('Error in enhanced bulk assignment:', error);
      
      // Fallback to regular bulk assignment
      try {
        const fallbackData = {
          leadIds: assignments.map(a => a.leadId),
          assignedTo: assignments[0]?.employeeId,
          assignmentNotes: assignments[0]?.notes || 'Bulk assignment',
          priority: assignments[0]?.priority || 'medium',
          assignmentMode: assignments[0]?.assignmentMode || 'replace' // Pass assignment mode
        };
        
        const response = await api.put('/lead-assignment/bulk-assign', fallbackData);
        return { success: true, data: response.data.data };
      } catch (fallbackError) {
        console.error('Fallback bulk assignment also failed:', fallbackError);
        return { 
          success: false, 
          error: fallbackError.response?.data?.message || 'Failed to assign leads' 
        };
      }
    }
  }

  // Get leads assigned to specific sales person
  static async getAssignedLeads(salesPersonId) {
    try {
      const response = await api.get(`/lead-assignment/assigned/${salesPersonId}`);
      return { success: true, data: response.data.data };
    } catch (error) {
      console.error('Error fetching assigned leads:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to fetch assigned leads' 
      };
    }
  }

  // Unassign lead
  static async unassignLead(leadId, unassignmentNotes = '') {
    try {
      const response = await api.put(`/lead-assignment/unassign/${leadId}`, {
        unassignmentNotes
      });
      return { success: true, data: response.data.data };
    } catch (error) {
      console.error('Error unassigning lead:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to unassign lead' 
      };
    }
  }

  // Get assignment statistics
  static async getAssignmentStats() {
    try {
      const response = await api.get('/lead-assignment/stats');
      return { success: true, data: response.data.data };
    } catch (error) {
      console.error('Error fetching assignment stats:', error);
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to fetch assignment statistics' 
      };
    }
  }
}

export default LeadAssignmentService;
